/** @format */

import {If} from 'frontier-utilities';
import React, {useState} from 'react';

export const CartRelatedOrders = ({orders, poNumber}) => {
    const [showAllRelatedOrders, setShowAllRelatedOrders] = useState(false);

    const handleToggle = () => {
        setShowAllRelatedOrders(prevState => !prevState);
    };

    if (!orders || orders.length < 1) return <></>;

    return (
        <>
            <p className={'m-0 p-0'}>
                {orders?.slice(0, showAllRelatedOrders ? orders.length : 3).map(order => (
                    <span
                        className={'m-0 p-0 d-block'}
                        key={order.id}
                        style={{
                            lineHeight: 1,
                            fontWeight: 'normal'
                        }}>
                        {order.id}
                    </span>
                ))}
            </p>
            {orders?.length > 3 && !showAllRelatedOrders && (
                <button
                    onClick={handleToggle}
                    className="btn btn-link m-0 p-0"
                    style={{height: '15px', fontSize: '14px'}}>
                    See all
                </button>
            )}
            {showAllRelatedOrders && (
                <button
                    onClick={handleToggle}
                    className="btn btn-link m-0 p-0"
                    style={{height: '15px', fontSize: '14px'}}>
                    See less
                </button>
            )}
            <If condition={!!poNumber}>
                <p className={'m-0 p-0 color-structure-darker'}>
                    <b>PO: {poNumber}</b>
                </p>
            </If>
        </>
    );
};
